<template>
  <!--解决方案页面-->
  <div class="companyProfile">
    <!--图片-->
    <div class="imgBox">
      <div class="imageItem">
        <img :src="itemData.imgBoxUrl" class="el-image__inner">
      </div>

    </div>
    <!--    导航-->
    <div class="num_all">
      <el-row >
        <el-col :span="18" :justify="end" ><div class="grid-content num_r">
          <el-menu :default-active="numIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
            <el-menu-item  v-for="item in itemData.numList" :index="item.num" :indexPath="item.path">{{item.tital}}</el-menu-item>
          </el-menu>
        </div></el-col>
      </el-row>
    </div>
    <div class="menuBox"></div>
    <!--    内容-->
    <div class="contentBox" v-show="item.showData" v-for="item in itemData.itemData">
      <div class="contentTitle">
        {{item.text1}}
      </div>
      <div class="contentImg">
        <div class="leftImg">
          <!--          <el-image
                      style="width: 578px; height: 700px"
                      :src="product1.img1"
                      :fit="contain"></el-image>-->
          <img :src="item.img1" alt="" class="imgoo">
        </div>
        <div class="rightImg">
          <div class="rightTopImg">

            <!--            <el-image
                          style="width: 578px; height: 340px"
                          :src="product1.img2"
                          :fit="contain"></el-image>-->
            <img :src="item.img2" alt="" class="imgoo">
          </div>
          <div class="rightBottomImg">
            <!--            <el-image
                          style="width: 578px; height: 340px"
                          :src="product1.img3"
                          :fit="contain"></el-image>-->
            <div class="rightBottomImg_1">
              <img :src="item.img3" alt="" class="imgoo">
            </div>
          </div>
        </div>
      </div>
      <div class="contentDetail">
        <div class="itemContent" >
          {{item.text2}}
        </div>
      </div>
    </div>
  </div>


</template>

<script>
import Mun2 from "./image/mun2";
import {Data} from "./js/companyProfile";
export default {
  name: "companyProfile",
  components: {Mun2},
  data() {
    return {

      urlData:"",
      showData:{
        box1: false
      },
      numIndex: "1",
      dataAll: Data,
      itemData: {},
    }
  },
  created() {
    let that = this;
    that.urlData = that.$route.query.path;
    console.log(that.urlData);

  },
  mounted() {
    let that = this;
    console.log(111)

    console.log(that.$parent.message)
    for(let index in that.dataAll){
      let itemData= that.dataAll[index];
      console.log(222)

      if(that.$parent.message == itemData.type){


        that.itemData = itemData;
        console.log(itemData)

        break;
      }
    }
    console.log("init");
    that.init();
  },
  methods: {
    init(){
      let that = this;
      console.log(that.urlData);
      console.log(that.urlData == undefined);
      if(that.urlData == "" || that.urlData == undefined){
        that.handleSelect("1",'dyy')
      } else {
        let index = "1";
        if(that.urlData == 'dyy'){
          index = "1";
        } else if(that.urlData == 'dys'){
          index = "2";
        } else if(that.urlData == 'dhz'){
          index = "3";
        }

        that.handleSelect(index,that.urlData)
      }

    },

    handleSelect(index, path) {
      let that = this;
      that.numIndex = index;
      console.log(index+path)  //获取tab标签的选中值
      console.log(index, path);
      //初始化
      // that.showData.box1 = false;
      for(let item in that.itemData.itemData){
         let sj = that.itemData.itemData[item]
        if(sj.num == index){
          sj.showData = true;
        } else {
          sj.showData = false;
        }
      }
      // that.showData.box1 = true;
      // if(index == '1'){
      //   that.showData.box1 = true;
      // }
    }
  }
}
</script>

<style scoped>
.num_all{
  background: #ffffff;
  font-family: SourceHanSansCN;
  font-size: 12px;
  text-align: justify;
  height: 60px;
  width: 100%;
}
.num_r{
  float: right;
}
.contentDetail{
  margin-top: 20px;
}
.itemContent{
  font-family: SourceHanSansCN;
  font-size: 18px;
  color: #666666;
  letter-spacing: 0.39px;
  text-align: justify;
  line-height: 32px;
  white-space: pre-wrap;
  text-indent: 2em;
}
.contentImg {
  margin-top: 50px;
  margin-bottom: 50px;
  width: 100%;
  aspect-ratio: 1176/700;
  display: flex;
}
.leftImg{
  border-radius: 10px;
  width: 49.15%;
}


.rightImg{
  width: 50.85%;
}
.imgoo{
  width: 100%;
  height: 100%;
  border-radius: 10px;

}
.rightTopImg{
  border-radius: 10px;

  width: 96.66%;
  margin-left: auto;
  height: 48.66%;


}

.rightBottomImg{
  border-radius: 10px;

  width: 96.66%;
  margin-left: auto;
  display: flex;
  flex-direction: column;
  height: 51.34%;
}
.rightBottomImg_1{
  width: 100%;
  margin-top: auto;
}

.contentTitle{
  font-family: SourceHanSansCN;
  font-size: 36px;
  color: #333333;
  text-align: justify;
  margin-top: 30px;
  margin-bottom: 20px;;
}
.contentBox {
  width: 61.25%;
  margin: 50px auto;
}
.companyProfile {
  display: block;
  width: 100%;
  background-color: #FFFFFF;
}
.imgBox {
  width: 100%;
  aspect-ratio: 1920/600;
}

.imageItem {
  height: 100%;
}

</style>



// WEBPACK FOOTER //
// src/components/companyProfile.vue